import { useState } from "react";

export default function RequestModal({ title, requestType, isOpen, onClose }) {
  const [form, setForm] = useState({ name: "", email: "" });
  const [status, setStatus] = useState({ loading: false, error: "", success: "" });

  if (!isOpen) return null;

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: "", success: "" });

    window.gtag?.("event", requestType, {
      form_name: requestType,
      form_location: 'landing_page',
    });

    try {
      const res = await fetch(`https://d1-fluetrack.anton-dacik.workers.dev/api/${requestType}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name.trim(),
          email: form.email.trim(),
        }),
      });

      if (!res.ok) throw new Error("Request failed");

      setStatus({ loading: false, error: "", success: "Request sent! We will contact you soon." });
      setForm({ name: "", email: "" });
    } catch {
      setStatus({ loading: false, error: "Could not send request. Please try again.", success: "" });
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close modal">
          ×
        </button>

        <h3 className="modal-title">{title}</h3>
        <p className="modal-subtitle">Leave your details and we’ll get back to you.</p>

        <form className="demo-form" onSubmit={onSubmit}>
          <label className="field">
            <span>Name</span>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={onChange}
              required
              placeholder="Your name"
            />
          </label>

          <label className="field">
            <span>Email</span>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={onChange}
              required
              placeholder="you@company.com"
            />
          </label>

          {status.error && <p className="form-error">{status.error}</p>}
          {status.success && <p className="form-success">{status.success}</p>}

          <button className="btn btn-primary" type="submit" disabled={status.loading}>
            {status.loading ? "Sending..." : "Send request"}
          </button>
        </form>
      </div>
    </div>
  );
}